<template>
  <div class="analysis-card-item">
    <div class="analysis-info-grid">
      <div class="info-column">
        <label>Proposta</label>
        <span class="value-highlight">{{ analysis.proposal }}</span>
      </div>

      <div class="info-column">
        <label>Status</label>
        <span :class="['status-badge', statusClass]">
          {{ analysis.approved || analysis.status }}
        </span>
      </div>

      <div class="info-column">
        <label>Data da análise</label>
        <span>{{ formatDateTime(analysis.analysisDate) }}</span>
      </div>

      <div class="info-column">
        <label>Responsável</label>
        <span>{{ analysis.responsible || '-' }}</span>
      </div>
    </div>

    <div class="analysis-actions">
      <b-button
        variant="light"
        v-b-tooltip.hover title="Visualizar"
        @click="$emit('view', analysis)"
      >
        <feather-icon icon="EyeIcon" size="16" />
      </b-button>

      <b-button
        variant="light"
        disabled
        v-b-tooltip.hover title="Iniciar Análise"
        @click="$emit('start-analysis', analysis)"
      >
        <feather-icon icon="PlayIcon" size="16" />
      </b-button>

      <b-button
        variant="light"
        :disabled="downloadInProgress"
        v-b-tooltip.hover title="Download"
        @click="$emit('download', analysis)"
      >
        <div v-if="isDownloading" class="dotted-spinner"></div>
        <feather-icon v-else icon="DownloadIcon" size="16" />
      </b-button>

      <b-button
        variant="light"
        v-b-tooltip.hover title="Histórico"
        @click="$emit('history', analysis)"
      >
        <feather-icon icon="ClockIcon" size="16" />
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import { DateTime } from 'luxon'

export default {
  name: 'AnalysisHistoryItem',

  components: { BButton },

  props: {
    analysis: {
      type: Object,
      required: true
    },
    downloadingAnalysisId: {
      type: [Number, String],
      default: null
    }
  },

  computed: {
    isDownloading() {
      const analysisId = this.analysis.id || this.analysis.analysis_id

      return this.downloadingAnalysisId !== null &&
        String(analysisId) === String(this.downloadingAnalysisId)
    },

    downloadInProgress() {
      return this.downloadingAnalysisId !== null
    },

  statusClass() {
    const status = String(
      this.analysis.approved || this.analysis.status || ''
    ).toLowerCase()

    if (status.includes('aprovad')) {
      return 'status-success'
    }

    if (status.includes('pendente')) {
      return 'status-warning'
    }

    if (status.includes('negad') || status.includes('reprovad')) {
      return 'status-danger'
    }

    return ''
  }
},

methods: {
  formatDateTime(date) {
    if (!date) return '-'
      return DateTime.fromISO(date).toFormat('dd/MM/yyyy HH:mm')
  }
}
}
</script>

<style scoped>
.analysis-card-item {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease;
}

.analysis-card-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-color: #cbd5e1;
}


.analysis-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 16px;
  margin-bottom: 14px;
}

.info-column {
  display: flex;
  flex-direction: column;
}

.info-column label {
  font-size: 11px;
  margin-bottom: 2px;
  font-weight: 500;
}

.info-column span {
  font-size: 13px;
}

.value-highlight {
  font-weight: 600;
}

.status-success {
  color: #10b981 !important;
  font-weight: 600;
}

.status-warning {
  color: #f59e0b !important;
  font-weight: 600;
}

.status-danger {
  color: #ef4444 !important;
  font-weight: 600;
}

.analysis-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  border-top: 1px solid #f1f5f9;
  padding-top: 10px;
}

.analysis-actions button {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #475569;
}

.analysis-actions button:hover:not(:disabled) {
  background: #656e77;
  color: #ffffff;
  border: none
}

.analysis-actions button svg {
  margin-right: 0 !important; 
}

.dotted-spinner {
  width: 18px;
  height: 18px;
  border: 3px dotted currentColor;
  border-radius: 50%;
  color: var(--primary);
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 600px) {
  .analysis-info-grid {
    grid-template-columns: 1fr;
  }
}
/* Dark mode */
.dark-layout .analysis-card-item {
  background: #1f2937;
  border-color: #374151;
  box-shadow:
    0 2px 6px rgba(0, 0, 0, 0.25),
    0 1px 2px rgba(0, 0, 0, 0.2);
}

.dark-layout .analysis-card-item:hover {
  border-color: #4b5563;
  box-shadow:
    0 6px 16px rgba(0, 0, 0, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.2);
}

.dark-layout .info-column label {
  color: #9ca3af;
}

.dark-layout .info-column span {
  color: #e5e7eb;
}

.dark-layout .value-highlight {
  color: #f3f4f6;
}

.dark-layout .analysis-actions {
  border-top-color: #374151;
}

.dark-layout .analysis-actions button {
  background: #263244;
  border-color: #3b4758;
  color: #cbd5e1;
}

.dark-layout .analysis-actions button:hover:not(:disabled) {
  background: #374151;
  border-color: #4b5563;
  color: #ffffff;
}

.dark-layout .analysis-actions button:disabled {
  background: #222c3a;
  border-color: #303b4a;
  color: #667085;
  opacity: 0.65;
}

</style>